export function supportsInert() {
  return "inert" in HTMLElement.prototype;
}
